import React, { useContext } from 'react'
import { MetricsContext } from '../context'
import { Card, CardHeading, CardContent } from '../../../components/layout/Card'
import { R } from '@utils/currency'

export const BudgetCards = () =>
  <div className='metrics-dashboard__budget-cards'>
    <AverageBudget />
    <TotalBudget />
  </div>

const AverageBudget = () => {
  const { state } = useContext(MetricsContext)
  const { averageCurrentBudget } = state
  return (
    <Card>
      <CardHeading>
        <h5>Average current budget</h5>
      </CardHeading>
      <CardContent>
        <h1 className='text-center'>{R(averageCurrentBudget).format()}</h1>
      </CardContent>
    </Card>
  )
}

const TotalBudget = () => {
  const { state } = useContext(MetricsContext)
  const { averageRetirementBudget } = state
  return (
    <Card>
      <CardHeading>
        <h5>Average retirement budget</h5>
      </CardHeading>
      <CardContent>
        <h1 className='text-center'>{R(averageRetirementBudget).format()}</h1>
      </CardContent>
    </Card>
  )
}
